/**
 * 转入股票表单字段壳：对齐 CRS `CrsFormField`（标签 + 控件 + 可选错误）。
 * Props 不解构，保持 cdui-js 响应式追踪。
 */
export type StiFormFieldProps = {
  label: string;
  children: unknown;
  error?: string;
  /** 控件下方说明（如数量备注） */
  hint?: string;
  /** warn：对齐转股首页 `.sti-tip` 灰底 + 红字 */
  hintTone?: 'muted' | 'warn';
};

export const StiFormField = (props: StiFormFieldProps) => (
  <div class={`sti-field-wrap${props.error ? ' sti-field-wrap-error' : ''}`}>
    <div class="sti-field-label font-s-S color">{props.label}</div>
    <div class="sti-field-control">{props.children}</div>
    {props.error ? <div class="sti-field-err font-s-XS color-error">{props.error}</div> : null}
    {props.hint ? (
      props.hintTone === 'warn' ? (
        <div class="sti-tip sti-tip-warn">{props.hint}</div>
      ) : (
        <div class="sti-field-hint font-s-XS color-L">{props.hint}</div>
      )
    ) : null}
  </div>
);
